import { render, staticRenderFns } from "./ExtendedView.vue?vue&type=template&id=a4588a7a"
import script from "./ExtendedView.vue?vue&type=script&lang=js"
export * from "./ExtendedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports